import type * as TechFilter from "app/pages/sales-intelligence/domain/technology/types/filter-values";
import type * as TechModel from "app/pages/sales-intelligence/domain/technology/types/model";

/** @deprecated import from "app/pages/sales-intelligence/domain/technology/types/model" */
export type GroupedTechnologies = TechModel.GroupedTechnologies;

/** @deprecated import from "app/pages/sales-intelligence/domain/technology/types/model" */
export type GroupedTechnologiesCategoryMap = TechModel.GroupedTechnologiesCategoryMap;

/** @deprecated import from "app/pages/sales-intelligence/domain/technology/types/filter-values" */
export type TechnologiesFilterDto = TechFilter.TechnologiesFilterDto;

export type SortedTechnologies = [
    ReadonlyArray<CategoryListItemType>,
    ReadonlyArray<SubCategoryListItemType>,
    ReadonlyArray<TechnologiesConditionEntry>,
];

export enum TechnologyDropdownTabType {
    Categories = "categories",
    SubCategories = "subCategories",
    Technologies = "technologies",
}

export enum TechnologiesConditionTypeEnum {
    Category = "category",
    SubCategory = "subCategory",
    Technology = "technology",
}

export const enum TechnologiesContentEnum {
    Category = "category",
    SubCategory = "subCategory",
    Technologies = "technologies",
}

export type TechnologiesConditionEntry = {
    readonly name: string;
    readonly type: TechnologiesConditionTypeEnum;
};

export type WithSecondaryName = {
    readonly secondaryName: string;
};

export type WithNamesMatchType = {
    readonly nameMatch?: string;
    readonly secondaryNameMatch?: string;
};

export type TechnologiesBaseListItem = TechnologiesConditionEntry;

export type CategoryListItemType = TechnologiesBaseListItem & TechFilter.WithTechnologiesCount;

export type SubCategoryListItemType = CategoryListItemType & WithSecondaryName;

export type TechnologyListItemType = TechnologiesBaseListItem & WithSecondaryName & { id: number };

export type TechnologiesDDItemType = TechnologiesBaseListItem &
    Partial<WithSecondaryName> &
    Partial<TechFilter.WithTechnologiesCount> &
    WithNamesMatchType & { isSelected?: boolean; isDisabled?: boolean };

export type TechnologiesListItems = {
    categories: readonly CategoryListItemType[];
    subCategories: readonly SubCategoryListItemType[];
    technologies: readonly TechnologyListItemType[];
};
